/**
 * A numbered page that runs `shift` cards past its own: the first page keeps
 * all of its own and adds the next page's first `shift`; a later page leaves
 * its first `shift` to the page before and adds the next page's first `shift`.
 * Every card appears once, and every page but the last is `pageSize` + (page 1) `shift`.
 */
export function windowShift<T>(own: T[], next: T[], page: number, shift: number): T[] {
  const start = page > 1 ? own.slice(shift) : own;
  return [...start, ...next.slice(0, shift)];
}

/** The page count once each page runs `shift` on: page 1 holds `pageSize + shift`, every later one `pageSize`. */
export function shiftedLastPage(total: number, pageSize: number, shift: number, fallback: number): number {
  if (!Number.isFinite(total) || total <= 0 || pageSize <= 0) return fallback;
  return Math.max(1, Math.ceil((total - shift) / pageSize));
}
